<template>
  <div class="wrapper">
    <el-carousel :interval="3000"
                 class="carouselUl">
      <el-carousel-item v-for="(item, i) in slideshowList"
                        :key="i">
        <img v-show="item.fileUrl.substr(-3)!=='mp4'"
             class="carouselItem"
             :src="item.fileLocal + item.fileUrl" />
        <video-player v-show="item.fileUrl.substr(-3)=='mp4'"
                      class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      :playsinline="true"
                      :options="playerOptions"></video-player>

      </el-carousel-item>
      <!-- <el-carousel-item>
        <video-player class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      :playsinline="true"
                      :options="playerOptions"></video-player>
      </el-carousel-item> -->
    </el-carousel>

    <div class="box">
      <div>
        <img :src="require('@/assets/images/组 40@2x (1).png')" />
        <div>提高业务运转效率</div>
      </div>
      <div>
        <img :src="require('@/assets/images/组 40@2x (2).png')" />
        <div>降低机构运营成本</div>
      </div>
      <div>
        <img :src="require('@/assets/images/组 40@2x (3).png')" />
        <div>规范检测业务流程</div>
      </div>
    </div>
    <div class="centerBox">
      <div class="titleBox">
        <div class="title">
          我们的产品
          <img :src="require('@/assets/images/矩形 20 拷贝@2x.png')" />
        </div>
        <div class="subheading">our products</div>
      </div>
      <div class="border">
        <div class="top">
          <div class="test">适用场景</div>
        </div>
        <div class="me-box">
          <div class="me-box-test1">全流程业务管理，助力 第三方独立医学实验室 提质增效</div>
          <div class="me-box-test2">遵循ISO15189/CAP体系管理要求，基于人、机、料、法、环多个模块，帮助检测机构打造智慧型实验室</div>
          <div class="me-box-border">
            <div class="border-box">
              <img class="border-box-img"
                   src="../../assets/集团型实验室.png"
                   alt="">
              <div class="border-box-kuang">
                <div class="box-kuang1">集团型实验室</div>
                <div class="box-kuang2">医学实验室由原先区域化运营逐步形成全国布局模式，集团化运营需求持续增长</div>
              </div>
            </div>
            <div class="border-box">
              <img class="border-box-img"
                   src="../../assets/个性化实验室.png"
                   alt="">
              <div class="border-box-kuang">
                <div class="box-kuang1">个性化实验室</div>
                <div class="box-kuang2">分子诊断技术、基因分析技术的提高，孕育着个性化实验室的数量将快速增长</div>
              </div>
            </div>
            <div class="border-box">
              <img class="border-box-img"
                   src="../../assets/临床研究实验室.png"
                   alt="">
              <div class="border-box-kuang">
                <div class="box-kuang1">临床研究实验室</div>
                <div class="box-kuang2">智慧型系统，为临床研究、药物研究实验室提供全流程解决方案</div>
              </div>
            </div>
          </div>
          <div class="top">
            <div class="test">适用场景</div>
          </div>
          <div class="box-model">
            <div class="model-border"
                 v-for="(item,index) in tableData"
                 :key="index">
              <div class="model-top">
                <div>{{ item.title }}</div>
                <img :src="item.fileLocal+item.iconUrl"
                     alt="">
              </div>
              <div class="model-test">{{ item.describe }}</div>
            </div>

            <div class="model-border"
                 style="cursor: pointer;"
                 @click="radio">
              <div class="model-border-image">更多功能<img style="width: 25px;height: 19px;margin-left: 10px;"
                     src="../../assets/更多-箭头.png"
                     alt=""></div>
            </div>
          </div>
        </div>

      </div>
      <!-- <div class="productBox">
        <div>
          <img :src="require('@/assets/images/组 43 拷贝@2x.png')"
               alt="" />
          <p>实验室信息管理系统</p>
          <div>查看</div>
        </div>
        <div>
          <img :src="require('@/assets/images/图层 59@2x.png')"
               alt="" />
          <p>检验数据平台</p>
          <div>查看</div>
        </div>
        <div>
          <img :src="require('@/assets/images/图层 60@2x.png')"
               alt="" />
          <p>销售数据平台</p>
          <div>查看</div>
        </div>
        <div>
          <img :src="require('@/assets/images/图层 61@2x.png')"
               alt="" />
          <p>基础数据平台</p>
          <div>查看</div>
        </div>
        <div>
          <img :src="require('@/assets/images/图层 62@2x.png')"
               alt="" />
          <p>监管平台</p>
          <div>查看</div>
        </div>
        <div>
          <img :src="require('@/assets/images/图层 63@2x.png')"
               alt="" />
          <p>质控EQA平台</p>
          <div>查看</div>
        </div>
      </div> -->
      <div style="margin-top: 70px;"
           class="titleBox">
        <div class="title">
          企业动态
          <img :src="require('@/assets/images/矩形 20 拷贝@2x.png')" />
        </div>
        <div class="subheading">company news</div>
      </div>
      <div class="enterpriseBox">
        <!-- <div class="dynamical" v-if="businessList.length">
          <div>
            <img
              :src="`${businessList[businessIndex].fileLocal}${businessList[businessIndex].fileUrl}`"
            />
          </div>
          <div>
            <div class="title">
     
              {{ businessList[businessIndex].title }}
            </div>
            <div class="text">
              {{ businessList[businessIndex].businessContentTag }}
            </div>
          </div>
        </div> -->
        <div class="dynamicalBox">
          <!-- :class="
              businessIndex === i ? 'dynamical active_dynamical' : 'dynamical'
            " -->
          <el-carousel :interval="3000"
                       ref="businessCarousel"
                       arrow="never"
                       indicator-position="none"
                       style="width: 100%; height: 100%"
                       @change="changeBusinessIndex">
            <el-carousel-item v-for="(item, i) in businessList"
                              :key="i">
              <div class="dynamical">
                <div>
                  <img :src="`${item.fileLocal}${item.fileUrl}`" />
                </div>
                <div>
                  <div class="title"  @click="detailFn(item)">
                    {{ item.title }}
                  </div>
                  <div class="text">
                    {{ item.businessContentTag }}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="moreBox"
             @click="moreFn">更多动态资讯 >></div>
        <div class="pageBox">
          <div v-for="(item, i) in businessList"
               :key="i"
               :class="i === businessIndex ? 'active' : ''"
               @click="changeBusinessIndex(i)">
            {{ i + 1 }}
          </div>
        </div>
      </div>
      <div class="titleBox">
        <div class="title">
          成功案例
          <img :src="require('@/assets/images/矩形 20 拷贝@2x.png')" />
        </div>
        <div class="subheading">successful cases</div>
        <div class="text">
          部分合作机构
        </div>
      </div>
      <el-carousel class="carouselBox"
                   :interval="3000"
                   arrow="never">
        <el-carousel-item v-for="(item, index) in caseMaintenanceList"
                          :key="index">
          <div class="cases">
            <img v-for="(li, i) in item"
                 :key="i"
                 :src="li.fileLocal + li.fileUrl" />
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="clientBox">
        <div class="titleBox">
          <div class="title">
            客户分布
            <img :src="require('@/assets/images/矩形 20 拷贝@2x.png')" />
          </div>
          <div class="subheading">customer distribution</div>
        </div>
        <img class="map"
             :src="require('@/assets/images/地图.gif')"
             alt="" />
      </div>
      <div class="consultBox"
           id="consultBox">
        <div class="test-title">
          咨询合作，赋能医疗机构<div class="colro">智能信息化</div>转型
        </div>
        <div class="consult">
          <div>
            <div>商务微信</div>

            <img v-if="contactList[0]"
                 :src="`${contactList[0].fileLocal}${contactList[0].quickMarkUrl}`"
                 alt="" />
            <div class="jingli"
                 v-if="contactList[0]">{{ contactList[0].contactName }}</div>
            <img v-if="contactList[1]"
                 :src="`${contactList[1].fileLocal}${contactList[1].quickMarkUrl}`"
                 alt="" />
            <div class="jingli"
                 v-if="contactList[1]">{{ contactList[1].contactName }}</div>
          </div>
          <div>
            <div class="consultTitleBox">
              <span class="consultTitle">在线留言</span>
              <span class="consultSubheading">我们的工作人员会在第一时间联系您</span>
            </div>
            <el-input class="input"
                      v-model="onlineName"
                      placeholder="请留下您的姓名">
              <span slot="prefix">
                <img class="prefixIcon"
                     :src="require('@/assets/images/椭圆 15@2x.png')"
                     alt="" />
              </span>
            </el-input>
            <el-input class="input"
                      v-model="onlinePhone"
                      placeholder="请留下您的电话">
              <span slot="prefix">
                <img class="prefixIcon"
                     :src="require('@/assets/images/图层 41@2x.png')"
                     alt="" />
              </span>
            </el-input>
            <el-input class="input"
                      type="textarea"
                      placeholder="您还可以在此留言，以便我们更精准的为您服务！"
                      resize="none"
                      v-model="onlineContent" />
            <el-button class="input submit"
                       type="primary"
                       round
                       @click="addOnlineFn">提交</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="weixin-box"
         @mouseover="onMouseOverO"
         @mouseleave="onMouseOutO">
      <img class="wx-img"
           src="../../assets/微信.png"
           alt="">
      <div class="wx-test">商务微信</div>
    </div>
    <div v-if="isShow"
         @mouseover="onMouseOverT"
         @mouseleave="onMouseOutT"
         class="weixin-border">
      <div v-for="(itemss,index) in contactList"
           :key="index">
        <img class="images"
             :src="itemss.fileLocal+itemss.quickMarkUrl"
             alt="">
        <div class="text-name">
          {{ itemss.contactName }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  getSlideshow,
  getBusiness,
  getCaseMaintenance,
  getContact,
  addOnline,
} from "./server";
import { videoPlayer } from "vue-video-player";
let flg = true
export default {
  name: "home",
  components: { videoPlayer },
  data () {
    return {
      onlineName: "",
      onlinePhone: "",
      onlineContent: "",
      businessIndex: 0, //企业动态选中数据
      slideshowList: [],
      businessList: [],
      caseMaintenanceList: [],
      contactList: [],
      timer: null,
      tableData: [],
      isShow: false,
      isCollapse: false,
      playerOptions: {
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            // src: JSON.parse(localStorage.getItem('live')).url, //url地址从上个页面中传入
            src: '', //url地址
          },
        ],
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      mpUrl: ''
    };
  },
  created () {
    this.init();
    this.getfunctionList()
    // this.timer = setInterval(() => {
    //   this.businessIndex =
    //     this.businessList.length - 1 > this.businessIndex
    //       ? this.businessIndex + 1
    //       : 0;
    // }, 3000);
  },

  methods: {
    radio () {
      this.$router.push(`/Solution?id=${1}`);
      // this.isCollapse = !this.isCollapse;

      // this.$bus.$emit("isCollapse", 1);
      // this.$router.push("/Solution");
    },
    detailFn (row) {
      this.$router.push(`/detail?id=${row.businessId}`);
    },
    onMouseOverO () {
      this.isShow = true
    },
    // 鼠标移出1
    onMouseOutO () {
      setTimeout(() => {
        if (flg) {
          this.isShow = false
        }
      }, 100)
    },
    // 鼠标移入2
    onMouseOverT () {
      flg = false
    },
    // 鼠标移出2
    onMouseOutT () {
      flg = true
      this.isShow = false
    },
    moreFn () {
      this.$router.push("/enterprise");
    },
    getfunctionList () {

      this.api.functionList({
        t: {

        }, p: {}
      }).then((res) => {
        console.log(res)
        if (res.data.rows.length > 9) {
          this.tableData = res.data.rows.slice(0, 8)
        } else {
          this.tableData = res.data.rows
        }
        // this.tableData = res.data.rows.slice(0, 7)
        // console.log(this.tableData, 'wwww')
      })
    },
    init () {
      //获取轮播图数据
      getSlideshow().then((res) => {
        this.slideshowList = res.rows;
        // let as = res.rows.map(item=>{
        //   // item.fileUrl.substr(-3)=='mp4'
        //   console.log( item.fileUrl.substr(-3))
        // })
        const obj = res.rows.find(item => item.fileUrl.substr(-3) === 'mp4')
        this.mpUrl = obj.fileLocal + obj.fileUrl
        this.playerOptions.sources[0].src = this.mpUrl
      });
      //获取企业动态数据
      getBusiness({
        t: {
          businessClassify: "1",
          publishStatus: "1",
        },
        p: {
          pageNum: 1,
          pageSize: 3,
        },
      }).then((res) => {
        console.log(res);
        this.businessList = res.data;
        console.log(this.businessList);
      });

      //成功案例
      getCaseMaintenance({
        t: {
          classify: "成功案例",
        },
      }).then((res) => {
        const arr = [];
        for (let i = 0; i < res.rows.length; i++) {
          const index = parseInt(i / 12);
          if (!arr[index]) arr[index] = [];
          arr[index].push(res.rows[i]);
        }
        this.caseMaintenanceList = arr;
      });

      //联系人
      getContact().then((res) => {
        this.contactList = res.rows.filter((item, i) => i < 2);
        console.log(this.contactList, res.rows, '1111');
      });
    },
    changeBusinessIndex (i) {
      this.businessIndex = i;
      this.$refs.businessCarousel.setActiveItem(i);
    },
    addOnlineFn () {
      addOnline({
        onlineName: this.onlineName,
        onlinePhone: this.onlinePhone,
        onlineContent: this.onlineContent,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg);
          this.onlineName = "";
          this.onlinePhone = "";
          this.onlineContent = "";
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.active_dynamical {
  // transition: all 1.5s;

  animation-name: opacityTransform;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  animation-direction: alternate;
}
@media (min-width: 1024px) {
  .weixin-box {
    position: fixed;
    z-index: 500;
    top: 410px;
    right: 40px;
    width: 108px;
    height: 153px;
    background: #ffffff;
    box-shadow: 0px 15px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 59px;
    .wx-img {
      margin-top: 30px;
      width: 55px;
      height: 55px;
    }
    .wx-test {
      margin-top: 15px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 300;
      color: #367dff;
    }
  }
  .weixin-border {
    position: fixed;
    z-index: 550;
    top: 290px;
    right: 150px;
    width: 196px;
    height: 410px;
    // background: #ffffff;
    // box-shadow: 8px 13px 15px 0px rgba(0, 0, 0, 0.05);
    background: url("../../assets/鼠标悬停气泡框.png");
    background-size: 100% 100%;
    .images {
      width: 116px;
      height: 116px;
      margin-right: 30px;
      margin-top: 20px;
      // margin: 0px auto;
    }
    .text-name {
      width: 110px;
      // border: 1px solid;
      margin-left: 30px;
      margin-top: 20px;
    }
    // border-radius: 11px;
  }
  .wrapper {
    position: relative;
    .carouselUl {
      height: 800px;
      overflow: hidden;
      ::v-deep .el-carousel__container {
        height: 100%;
      }
      ::v-deep .el-carousel__indicators {
        bottom: 150px;
        li button {
          width: 30px;
          height: 10px;
          border-radius: 10px;
        }
      }
    }
    .carouselUl:after {
      content: "";
      display: block;
      width: 100%;
      padding-top: 4.377%;
      background-image: url(../../assets/images/zy1.png);
      background-size: 100% 100%;
      position: absolute;
      left: 0;
      bottom: -1px;
      z-index: 2;
      background-repeat: no-repeat;
      overflow: hidden;
    }
    .carouselBox {
      margin: 0 auto;
      // border: 1px solid;
      width: 1200px;
      height: 530px;
      margin-top: 20px;
      margin-bottom: 50px;
      ::v-deep .el-carousel__container {
        height: 100%;
      }
    }
    .carouselItem {
      width: 100%;
      height: 100%;
    }
    .box {
      position: absolute;
      top: 655px;
      left: 50%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 1200px;
      height: 345px;
      background: linear-gradient(0deg, #ffffff, #ebf0f8);
      box-shadow: 0px 7px 103px 0px rgba(52, 59, 72, 0.13);
      border-radius: 35px;
      padding: 37px;
      transform: translate(-50%);
      z-index: 5;
      > div {
        width: 30%;
      }
      > div > img {
        width: 45%;
      }
      > div > div {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #505050;
      }
    }
  }
  .centerBox {
    width: 100%;
    padding-top: 260px;
    .titleBox {
      width: 100%;
      .title {
        margin: 0 auto;
        width: 500px;
        font-size: 46px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #367dff;
        position: relative;
        > img {
          width: 100%;

          position: absolute;
          top: 50%;
          left: 0;
        }
      }
      .subheading {
        font-size: 43px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #cbd6ea;
      }
      .text {
        font-family: PingFangSC-Medium, PingFang SC;
        margin-top: 30px;
        font-size: 28px;
        margin-bottom: 25px;
        font-weight: 400;
      }
    }
    .border {
      // height: 1400px;
      width: 100%;
      background: url("../../assets//我们的产品-背景.png");
      background-size: 100% 100%;
      margin-top: 40px;
      .top {
        height: 130px;
        width: 288px;
        display: flex;
        // border: 1px solid red;
        margin: 0 auto;
        .test {
          // border: 1px solid red;
          margin-top: 45px;
          height: 99px;
          width: 288px;
          background: url("../../assets/qipao.png");
          background-size: 100% 100%;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          line-height: 60px;
          // margin: auto;
        }
      }
      .me-box {
        margin: 0 auto;
        width: 1200px;
        // border: 1px solid red;
        // height: 1200px;
        .me-box-test1 {
          margin-top: 25px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #ffffff;
        }
        .me-box-test2 {
          margin-top: 15px;
          font-size: 17px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 300;
          color: #ffffff;
        }
        .me-box-border {
          margin: 0 auto;
          margin-top: 50px;
          // margin-left: 4%;
          height: 540px;
          width: 96%;
          // border: 1px solid red;
          display: flex;
          .border-box {
            margin: 0 20px;
            // border: 1px solid red;
            width: 30%;
            .border-box-img {
              width: 275px;
              height: 292px;
            }
            .border-box-kuang {
              margin-top: 25px;
              width: 341px;
              height: 206px;
              // background: #ffffff;
              border: 1px solid rgba(170, 169, 169, 0.92);
              border-radius: 8px;
              .box-kuang1 {
                margin-top: 30px;
                font-size: 23px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #ffffff;
              }
              .box-kuang2 {
                width: 289px;
                height: 77px;
                font-size: 17px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 300;
                color: #e4e4e4;
                text-align: left;
                margin: 0 auto;
                margin-top: 30px;
              }
            }
          }
        }
        .box-model {
          margin-left: -13px;
          // height: 600px;
          width: 1230px;
          // border: 1px solid red;
          display: flex;
          padding-bottom: 50px;
          flex-wrap: wrap;
          align-content: flex-start;
          .model-border {
            width: 378px;
            height: 187px;
            background: #ffffff;
            border: 2px solid #364664;
            opacity: 0.9;
            margin: 0 15px;
            margin-top: 30px;
            border-radius: 10px;
            .model-border-image {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #383838;
              line-height: 187px;
              margin: auto;
            }
            .model-top {
              display: flex;
              width: 314px;
              height: 60px;
              // border: 1px solid red;
              margin: 0 auto;
              margin-top: 30px;
              > div {
                width: 260px;
                text-align: left;
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #383838;
                line-height: 60px;
              }
              > img {
                // display: flex;
                justify-content: flex-end;
                width: 44px;
                height: 44px;
              }
            }
            .model-test {
              font-family: PingFangSC-Medium, PingFang SC;
              width: 314px;
              // border: 1px solid red;
              height: 80px;
              font-size: 16px;
              font-weight: 300;
              color: #383838;
              line-height: 24px;
              text-align: left;
              margin: 0 auto;
            }
          }
        }
      }
    }
    .productBox {
      width: 100%;
      padding: 40px 345px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      > div {
        width: 30%;
        height: 378px;
        background: rgba(64, 131, 255, 0);
        border: 3px solid rgba(54, 125, 255, 0.15);
        border-radius: 19px;
        margin-bottom: 40px;
        text-align: center;
        > img {
          width: 95px;
          height: 83px;
          margin-top: 68px;
        }
        > p {
          margin-top: 50px;
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          color: #3f3f3f;
        }
        > div {
          margin-left: auto;
          margin-right: auto;
          margin-top: 60px;
          width: 33%;
          height: 38px;
          background: rgba(54, 125, 255, 0);
          border: 1px solid #2c6ce5;
          border-radius: 8px;
          color: #2c6ce5;
          line-height: 38px;
        }
      }
      > :hover {
        box-shadow: 0px 7px 32px 0px rgba(0, 0, 0, 0.1);
      }
      > :nth-child(3n) {
        margin-right: 0;
      }
    }
    .enterpriseBox {
      margin-top: 62px;
      margin-bottom: 74px;
      width: 100%;
      height: 644px;
      background-image: url("../../assets/images/组 41 拷贝@2x.png");
      background-size: 100% 100%;
      position: relative;
      overflow: hidden;
      .dynamicalBox {
        width: 1140px;
        height: 70%;
        background-color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        box-shadow: 0px 13px 40px 0px rgba(0, 0, 0, 0.15);
        border-radius: 29px;
        display: flex;
        align-items: center;

        ::v-deep .el-carousel__container {
          height: 100%;
        }
      }
      .dynamical {
        flex-shrink: 0;
        width: 1140px;
        height: 100%;
        background-color: white;
        // position: absolute;
        // top: 50%;
        // left: 50%;
        // transform: translate(-50%, -50%);
        box-shadow: 0px 13px 40px 0px rgba(0, 0, 0, 0.15);
        border-radius: 29px;
        display: flex;
        > div {
          width: 50%;
          height: 100%;
          > img {
            width: 100%;
            height: 100%;
            border-radius: 29px !important;
            // border-top-left-radius:  29px;
            // border-bottom-left-radius:  29px;
          }
          > .title {
            width: 100%;
            font-size: 36px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #2d2d2d;
            text-align: start;
            cursor: pointer;
          }
          > .text {
            margin-top: 20px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 300;
            color: #2d2d2d;
            text-align: start;
            max-height: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 6;
            -webkit-box-orient: vertical;
          }
          > .title:hover {
          color: #417af5;
        }
        }
        > :last-child {
          padding: 60px 65px 50px 70px;
        }
      }
      .moreBox {
        position: absolute;
        left: 50%;
        bottom: 35px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        transform: translate(-50%);
        cursor: pointer;
      }
      .pageBox {
        position: absolute;
        right: 500px;
        bottom: 35px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        display: flex;
        > div {
          width: 38px;
          height: 38px;
          border: 1px solid white;
          border-radius: 50%;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 38px;
          cursor: pointer;
          margin-left: 20px;
        }
        > .active {
          background-color: white;
          color: #000;
          transition: all 1.5s;
        }
      }
    }
    .cases {
      // padding: 0 296px;
      display: flex;
      flex-wrap:wrap;
      > img {
        width: 280px;
        height: 151px;
        // border: 1px solid #8c8787;
        // margin-left: 12.5px;
        margin-right: 12.5px;
        margin-bottom: 27px;
        border-radius: 20px;
        box-shadow: 1px 0px 2px 1px rgba(0, 0, 0, 0.1);
      }
    }
    .clientBox {
      width: 100%;
      height: 1230px;
      background-image: url("../../assets/images/组 41@2x (1).png");
      background-size: 100% 100%;
      padding-top: 84px;
      .map {
        width: 60%;
        height: 70%;
      }
    }
    .consultBox {
      width: 100%;
      height: 900px;
      background-image: url("../../assets/留言板背景.png");
      background-size: 100% 100%;
      position: relative;
      .test-title {
        width: 100%;
        // margin: 0 auto;
        // text-align: center;
        font-size: 44px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        padding-top: 70px;
        justify-content: center;
        color: #ffffff;
        display: flex;
        .colro {
          color: #6fa2ffff;
        }
      }

      .consult {
        width: 1200px;
        height: 70%;
        background-color: white;
        border-radius: 32px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -40%);
        overflow: hidden;
        display: flex;
        > :first-child {
          width: 40%;
          height: 100%;
          background: linear-gradient(141deg, #546a93, #364664);
          padding: 25px 0;
          > div {
            color: white;
            font-size: 28px;
            margin-top: 20px;
          }
          > img {
            width: 179px;
            height: 179px;
            margin-top: 30px;
          }
          .jingli {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
          }
        }
        > :last-child {
          width: 60%;
          height: 100%;
          padding: 35px;
        }
        .consultTitleBox {
          width: 100%;
          text-align: start;
          margin-bottom: 30px;
          > .consultTitle {
            font-size: 36px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #424242;
          }
          > .consultSubheading {
            margin-left: 35px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 400;
            color: #535353;
          }
        }
        .input {
          margin-top: 15px;
        }
        .submit {
          width: 165px;
          height: 70px;
          background: #367dff;
          border-radius: 41px;
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          float: left;
        }
        ::v-deep .el-input__inner {
          height: 80px;
          line-height: 80px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          padding-left: 90px;
          border-radius: 13px;
        }
        ::v-deep .el-textarea__inner {
          height: 170px !important;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          border-radius: 13px;
        }
        ::v-deep .el-input__prefix {
          width: 86px;
          height: 80px;
          text-align: center;
          line-height: 80px;
          > span {
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 100px;
          }
        }
      }
      .prefixIcon {
        width: 36px;
        height: 36px;
        margin-top: 24px;
        // margin: auto;
      }
    }
  }
}
@media (max-width: 1024px) {
  .weixin-box {
    position: fixed;
    z-index: 500;
    top: 310px;
    right: 35px;
    width: 58px;
    height: 88px;
    background: #ffffff;
    box-shadow: 0px 15px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 59px;
    .wx-img {
      margin-top: 15px;
      width: 28px;
      height: 28px;
    }
    .wx-test {
      margin-top: 5px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 300;
      color: #367dff;
    }
  }
  .weixin-border {
    position: fixed;
    z-index: 550;
    top: 215px;
    right: 90px;
    width: 136px;
    height: 280px;
    // background: #ffffff;
    // box-shadow: 8px 13px 15px 0px rgba(0, 0, 0, 0.05);
    background: url("../../assets/鼠标悬停气泡框.png");
    background-size: 100% 100%;
    .images {
      width: 76px;
      height: 76px;
      margin-right: 20px;
      margin-top: 20px;
      // margin: 0px auto;
    }
    .text-name {
      width: 80px;
      // border: 1px solid;
      margin-left: 22px;
      margin-top: 10px;
    }
    // border-radius: 11px;
  }
  .wrapper {
    position: relative;
    .carouselUl {
      height: 800px;
      overflow: hidden;
      ::v-deep .el-carousel__container {
        height: 100%;
      }
      ::v-deep .el-carousel__indicators {
        bottom: 150px;
        li button {
          width: 30px;
          height: 10px;
          border-radius: 10px;
        }
      }
    }
    .carouselUl:after {
      content: "";
      display: block;
      width: 100%;
      padding-top: 4.377%;
      background-image: url(../../assets/images/zy1.png);
      background-size: 100% 100%;
      position: absolute;
      left: 0;
      bottom: -1px;
      z-index: 2;
      background-repeat: no-repeat;
      overflow: hidden;
    }
    .carouselBox {
      margin: 0 auto;
      // border: 1px solid;
      width: 300px;
      height: 530px;
      margin-top: 20px;
      margin-bottom: 50px;
      ::v-deep .el-carousel__container {
        height: 100%;
      }
    }
    .carouselItem {
      width: 100%;
      height: 100%;
    }
    .box {
      position: absolute;
      top: 655px;
      left: 50%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 300px;
      height: 145px;
      background: linear-gradient(0deg, #ffffff, #ebf0f8);
      box-shadow: 0px 7px 103px 0px rgba(52, 59, 72, 0.13);
      border-radius: 35px;
      padding: 37px;
      transform: translate(-50%);
      z-index: 5;
      > div {
        width: 30%;
      }
      > div > img {
        width: 45%;
      }
      > div > div {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #505050;
      }
    }
  }
  .wrapper {
    position: relative;
    .carouselUl {
      height: 500px;
      overflow: hidden;
      ::v-deep .el-carousel__container {
        height: 100%;
      }
      ::v-deep .el-carousel__indicators {
        bottom: 150px;
        // li button {
        //   width: 30px;
        //   height: 20px;
        //   border-radius: 10px;
        // }
      }
    }
    .carouselUl:after {
      content: "";
      display: block;
      width: 100%;
      padding-top: 4.377%;
      background-image: url(../../assets/images/zy1.png);
      background-size: 100% 100%;
      position: absolute;
      left: 0;
      bottom: -1px;
      z-index: 2;
      background-repeat: no-repeat;
      overflow: hidden;
    }
    .carouselBox {
      height: 630px;
      margin-top: 20px;
      ::v-deep .el-carousel__container {
        height: 100%;
      }
    }
    .carouselItem {
      width: 100%;
      height: 100%;
    }
    .box {
      position: absolute;
      top: 355px;
      left: 50%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 80%;
      background: linear-gradient(0deg, #ffffff, #ebf0f8);
      box-shadow: 0px 7px 103px 0px rgba(52, 59, 72, 0.13);
      border-radius: 15px;
      padding: 15px;
      transform: translate(-50%);
      z-index: 5;
      > div {
        width: 30%;
      }
      > div > img {
        width: 80%;
      }
      > div > div {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #505050;
      }
    }
  }
  .centerBox {
    width: 100%;

    .titleBox {
      width: 100%;
      .title {
        margin: 0 auto;
        width: 200px;
        font-size: 23px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #367dff;
        position: relative;
        > img {
          width: 100%;
          position: absolute;
          top: 50%;
          left: 0;
        }
      }
      .subheading {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #cbd6ea;
      }
      .text {
        font-family: PingFangSC-Medium, PingFang SC;
        margin-top: 30px;
        font-size: 18px;
        margin-bottom: 25px;
        font-weight: 400;
      }
    }
    .border {
      // height: 1400px;
      width: 100%;
      background: url("../../assets//我们的产品-背景.png");
      background-size: 100% 100%;
      margin-top: 40px;
      .top {
        height: 130px;
        width: 288px;
        display: flex;
        // border: 1px solid red;
        margin: 0 auto;
        .test {
          // border: 1px solid red;
          margin-top: 45px;
          height: 99px;
          width: 288px;
          background: url("../../assets/qipao.png");
          background-size: 100% 100%;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          line-height: 60px;
          // margin: auto;
        }
      }
      .me-box {
        margin: 0 auto;
        width: 300px;
        // border: 1px solid red;
        // height: 1200px;
        .me-box-test1 {
          margin-top: 25px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #ffffff;
        }
        .me-box-test2 {
          margin-top: 15px;
          font-size: 17px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 300;
          color: #ffffff;
        }
        .me-box-border {
          margin: 0 auto;
          margin-top: 50px;
          // margin-left: 4%;
          // height: 540px;
          width: 320px;
          // border: 1px solid red;
          display: flex;
          flex-wrap: wrap;
          .border-box {
            // margin: 0 20px;
            // border: 1px solid red;
            // width: 30%;
            margin-bottom: 80px;
            .border-box-img {
              width: 275px;
              height: 292px;
            }
            .border-box-kuang {
              margin-top: 25px;
              width: 300px;
              height: 206px;
              // background: #ffffff;
              border: 1px solid rgba(170, 169, 169, 0.92);
              border-radius: 8px;
              .box-kuang1 {
                margin-top: 30px;
                font-size: 23px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #ffffff;
              }
              .box-kuang2 {
                width: 249px;
                height: 77px;
                font-size: 17px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 300;
                color: #e4e4e4;
                text-align: left;
                margin: 0 auto;
                margin-top: 30px;
              }
            }
          }
        }
        .box-model {
          margin-left: -13px;
          // height: 600px;
          width: 320px;
          // border: 1px solid red;
          display: flex;
          padding-bottom: 50px;
          flex-wrap: wrap;
          align-content: flex-start;
          .model-border {
            width: 320px;
            height: 177px;
            background: #ffffff;
            border: 2px solid #364664;
            opacity: 0.9;
            margin: 0 15px;
            margin-top: 30px;
            border-radius: 10px;
            .model-border-image {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #383838;
              line-height: 177px;
              margin: auto;
            }
            .model-top {
              display: flex;
              width: 260px;
              height: 60px;
              // border: 1px solid red;
              margin: 0 auto;
              margin-top: 30px;
              > div {
                width: 196px;
                text-align: left;
                font-size: 22px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #383838;
                line-height: 60px;
              }
              > img {
                // display: flex;
                justify-content: flex-end;
                width: 44px;
                height: 44px;
              }
            }
            .model-test {
              font-family: PingFangSC-Medium, PingFang SC;
              width: 260px;
              // border: 1px solid red;
              height: 80px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 300;
              color: #383838;
              line-height: 24px;
              text-align: left;
              margin: 0 auto;
            }
          }
        }
      }
    }
    .productBox {
      width: 100%;
      padding: 20px 37px;
      text-align: center;
      > div {
        width: 80%;
        height: 300px;
        background: rgba(64, 131, 255, 0);
        border: 3px solid rgba(54, 125, 255, 0.15);
        box-shadow: 0px 7px 32px 0px rgba(0, 0, 0, 0.1);
        margin: 0 auto;
        border-radius: 19px;
        margin-bottom: 40px;
        text-align: center;
        > img {
          width: 95px;
          height: 83px;
          margin-top: 35px;
        }
        > p {
          margin-top: 30px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          color: #3f3f3f;
        }
        > div {
          margin-left: auto;
          margin-right: auto;
          margin-top: 50px;
          width: 33%;
          height: 38px;
          background: rgba(54, 125, 255, 0);
          border: 1px solid #2c6ce5;
          border-radius: 8px;
          color: #2c6ce5;
          line-height: 38px;
        }
      }
    }
    .enterpriseBox {
      margin-top: 40px;
      margin-bottom: 74px;
      width: 100%;
      height: 260px;
      background-image: url("../../assets/images/组 41 拷贝@2x.png");
      background-size: 100% 100%;
      position: relative;
      overflow: hidden;
      .dynamicalBox {
        overflow: hidden;
        width: 80%;
        height: 70%;
        background-color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // translate: -50% -50%;
        box-shadow: 0px 13px 40px 0px rgba(0, 0, 0, 0.15);
        border-radius: 29px;
        overflow: hidden;
        display: flex;
        ::v-deep .el-carousel__container {
          height: 100%;
        }
      }
      .dynamical {
        width: 100%;
        height: 100%;
        background-color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // translate: -50% -50%;
        box-shadow: 0px 13px 40px 0px rgba(0, 0, 0, 0.15);
        border-radius: 29px;
        overflow: hidden;
        display: flex;
        > div {
          width: 50%;
          height: 100%;
          > img {
            width: 100%;
            height: 100%;
          }
          > .title {
            width: 100%;
            max-height: 40px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #2d2d2d;
            text-align: start;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
          }
          > .text {
            margin-top: 5px;
            max-height: 97px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 300;
            color: #2d2d2d;
            text-align: start;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 6;
          }
        }
        > :last-child {
          padding: 20px 10px 50px 10px;
        }
      }
      .moreBox {
        position: absolute;
        left: 50%;
        bottom: 15px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        transform: translate(-50%);
        cursor: pointer;
      }
      .pageBox {
        position: absolute;
        right: 40px;
        bottom: 12px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        display: flex;
        > div {
          width: 20px;
          height: 20px;
          border: 1px solid white;
          border-radius: 50%;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #ffffff;
          line-height: 20px;
          cursor: pointer;
          margin-left: 5px;
        }
        > .active {
          background-color: white;
          color: #000;
          transition: all 1.5s;
        }
      }
    }
    .cases {
      padding: 0 10%;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      height: 100%;
      > img {
        width: 45%;
        height: 90px;
        border-radius: 20px;
        box-shadow: 1px 0px 2px 1px rgba(0, 0, 0, 0.1);
      }
    }
    .clientBox {
      width: 100%;
      height: 500px;
      background-image: url("../../assets/images/组 41@2x (1).png");
      background-size: 100% 100%;
      padding-top: 84px;
      .map {
        width: 60%;
        height: 70%;
      }
    }
    .test-title {
      width: 100%;
      // margin: 0 auto;
      // text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      padding-top: 35px;
      justify-content: center;
      color: #ffffff;
      display: flex;
      .colro {
        color: #6fa2ffff;
      }
    }
    .consultBox {
      width: 100%;
      height: 400px;
      background-image: url("../../assets/留言板背景.png");
      background-size: 100% 100%;
      position: relative;
      .consult {
        width: 90%;
        height: 70%;
        background-color: white;
        border-radius: 32px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -40%);
        overflow: hidden;
        display: flex;
        > :first-child {
          width: 40%;
          height: 100%;
          background: linear-gradient(141deg, #546a93, #364664);
          padding: 10px 0;
          > div {
            color: white;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            margin-top: 8px;
          }
          > img {
            height: 30%;
            margin-top: 10px;
          }
        }
        > :last-child {
          width: 60%;
          height: 100%;
          padding: 14px;
        }
        .consultTitleBox {
          width: 100%;
          text-align: start;
          margin-bottom: 10px;
          > .consultTitle {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #424242;
          }
          > .consultSubheading {
            margin-left: 5px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 400;
            color: #535353;
          }
        }
        .input {
          margin-top: 5px;
        }
        .submit {
          // width: 188px;
          // height: 83px;
          // background: #367dff;
          // border-radius: 41px;
          float: left;
        }
        ::v-deep .el-input__inner {
          border-radius: 13px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
        }
        ::v-deep .el-textarea__inner {
          height: 70px !important;
          border-radius: 13px;
        }
        ::v-deep .el-input__prefix {
          text-align: center;
          line-height: 40px;

          > span {
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 50px;
          }
        }
      }
      .prefixIcon {
        width: 20px;
        height: 20px;
        margin: auto;
      }
    }
  }
}

@keyframes opacityTransform {
  0% {
    opacity: 0.1;
    transform: translate(50%, -50%);
  }
  // 50% {
  //   opacity: 0.5;
  //   transform: translate(0%, -70%);
  // }
  // 75% {
  //   opacity: 0.7;
  //   // transform: translate(30%);
  // }
  100% {
    opacity: 1;
  }
}
@keyframes UNopacityTransform {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
  // 50% {
  //   opacity: 0.7;
  // }
  // 75% {
  //   opacity: 0.5;
  // }
  100% {
    opacity: 0;
    transform: translate(-100%, -50%);
  }
}
</style>
